export const woundSchemaTabValues = {
  attributes: ["tissue", "exudate", "surroundingTissue", "pain"],
  progress: ["orders", "notes"],
  treatment: ["treatment"],
  describe: ["description"]
};
